import { CategoryModel } from 'Models';
import fixFloat from 'common/helpers/fixFloat';

class CommUnityCategoryModel extends CategoryModel {
  get total() {
    return this.lineItems?.reduce((total, lineItem) => fixFloat(total + lineItem.total), 0) || 0;
  }

  get upfrontTotal() {
    return this.lineItems?.reduce((total, lineItem) => fixFloat(total + lineItem.upfrontTotal), 0) || 0;
  }

  get recurringTotal() {
    return this.lineItems?.reduce((total, lineItem) => fixFloat(total + lineItem.recurringTotal), 0) || 0;
  }
}

export default CommUnityCategoryModel;
